import React, { Component } from 'react';
import { Container, Button, Form, Input, Row, Col, Collapse, CardHeader, ListGroup, ListGroupItem, CardBody, Card, ModalHeader, ModalBody, Modal, UncontrolledCollapse, CardText } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import history from '../../historial'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'

import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify';

import CambiarNombre from '../../Componentes/Modificaciones/cambiarNombre'
import CambiarApellidoPaterno from '../../Componentes/Modificaciones/cambiarApellidoPaterno'
import CambiarApellidoMaterno from '../../Componentes/Modificaciones/cambiarApellidoMaterno'
import CambiarUsuario from '../../Componentes/Modificaciones/cambiarUsuario'
import CambiarContra from '../../Componentes/Modificaciones/cambiarContraseña'
 
export default class ConfiguracionesAdmin extends Component {
    constructor(state) {
        super(state);
        this.state = {
            despliegue: false,
            vista: '',
            eliminar: '',
            isDelModalOpen: null,
            grupo: {},
            opciones: [{
                titulo: "Cuenta",
                contenido:
                    [{ titulo: "Cambiar nombre", componente: <CambiarNombre /> },
                    { titulo: "Cambiar apellido paterno", componente: <CambiarApellidoPaterno /> },
                    { titulo: "Cambiar apellido materno", componente: <CambiarApellidoMaterno /> },
                    { titulo: "Cambiar usuario", componente: <CambiarUsuario /> },
                    { titulo: "Cambiar contraseña", componente: <CambiarContra /> }]
            }]
        }
        this.test = this.test.bind(this)
        this.toggleDel = this.toggleDel.bind(this)
        this.logOut = this.logOut.bind(this);
        this.actualizarLista = this.actualizarLista.bind(this)
        this.dateToString = this.dateToString.bind(this)
        this.grupo = this.grupo.bind(this)
    }

    componentDidMount() {
        this.actualizarLista();
    } 
    
    actualizarLista(){
        const id = sessionStorage.getItem('_id');
        const grupo = sessionStorage.getItem('grupo');

        Fetch('/api/getMiGrupo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, grupo })
        })
            .then(response => {
                this.setState({ grupo: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        toast.error('Datos no encontrados')
                        break;

                    case 605:
                        toast.info('No existen coincidencias')
                        this.setState({ grupo: {} })
                        break;

                    default:
                        toast.error("Se produjo un error de conexion")
                        console.log(err)
                        break;
                }
        })
    }

    toggleDel(obj) {
        this.setState({
            isDelModalOpen: obj ? obj : null
        })
    }

    eliminar(e){
        e.preventDefault();

        if(sessionStorage.getItem('usuario') === this.state.eliminar){
            Fetch('/api/deleteCuenta', {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: sessionStorage.getItem('_id') })
            })
                .then(response => {
                    this.logOut();
                })
                .catch(err => {
                    switch (err.status) {

                        case 600:
                            console.log('Error inesperado')
                            break;

                        case 602:
                            console.log('Este usuario no existe')
                            break;

                        default:
                            break;
                    }
                })
        }else{
            toast.error('El nombre de usuario no coincide')
        }

    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    logOut() {
        localStorage.removeItem('token')
        sessionStorage.removeItem('data')
        history.push('/')
    }

    test(componente) {
        this.setState({ vista: componente })
    }

    dateToString(fechaHora) {
        var date = new Date(fechaHora);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    returnState(){
        this.actualizarLista();
        this.grupo();
    }

    cambiarEstado = (props) => {
        const { _id, completado } = props
        var id = _id
        var estado = !completado

        Fetch('/api/updateCompletarTarea', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, estado })
        })
            .then(response => {
                this.returnState();
                
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Este elemento no existe')
                        break;
                        
                    default:
                        break;
                }
            })
    }

    grupo(){
        this.setState({
            vista: <div>{this.state.grupo ? <Card className="my-3 border-1 border-dark" style={{height: '500px'}}><CardHeader className="text-center bg-dark text-white"><h4>{this.state.grupo.nombre}</h4></CardHeader><CardBody><Row><Button id="toggler1" className="w-100 text-left bg-white text-dark rounded-0 border-1 border-left border-right"><h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mensajes</h4></Button><UncontrolledCollapse className="w-100" toggler="#toggler1"><Card className="rounded-0 border-1 w-100 no-gutters" style={{ height: '180px'}}><CardBody><Row className="h-100 overflow-auto">{this.state.grupo.mensajes.map((index)=> (<Col sm="6" className="col-6 mb-4"><div><Card className="p-3"><CardText>{index.mensaje}</CardText><CardText><small className="text-muted">{this.dateToString(index.fechaHora)}</small></CardText></Card></div></Col>))}</Row></CardBody></Card></UncontrolledCollapse></Row><Row><Button id="toggler2" className="p-2 w-100 text-left bg-white text-dark rounded-0 border-1 border-left border-right"><h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tareas</h4></Button><UncontrolledCollapse className="w-100" toggler="#toggler2"><Card className="rounded-0 border-1 w-100" style={{ height: '180px'}} ><CardBody><Row className="h-100 overflow-auto">{this.state.grupo.tareas.map((index)=> (<Col sm="6" className="col-6 mb-4"><div><Card className="p-3"><CardText>{index.titulo}</CardText><CardText>{index.descripcion}</CardText><CardText> {index.completado ? <Button className="bg-success" onClick={()=>this.cambiarEstado(index)}>Terminado</Button> : <Button className="bg-secondary" onClick={()=>this.cambiarEstado(index)} >En progreso...</Button>}</CardText><CardText><small className="text-muted">{this.dateToString(index.fechaHora)}</small></CardText></Card></div></Col>))}</Row></CardBody></Card></UncontrolledCollapse></Row></CardBody></Card> : <Col><Card className="d-flex p-5 text-center shadow my-3 h-100">En este momento no estas inscrito a ningún grupo</Card></Col>}</div>
        })
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <h1 class="mt-2 mb-2 text-center">Configuracion</h1>
                                <div className="p-4">
                                    <Container>
                                        <Row>
                                            <Col xs="12" md="5">
                                                <Card className="container-default mb-3 mt-2 col-10 mx-auto" style={{height:'50em'}}>
                                                    <div className="col-12 scroll">
                                                        <ListGroup className="my-3">
                                                            {this.state.opciones.map((element) =>
                                                                <div>
                                                                    <button active type="button" onClick={() => this.setState((state) => ({despliegue: !state.despliegue }))} class="list-group-item list-group-item-action">{element.titulo}</button>

                                                                    <Collapse isOpen={this.state.despliegue}>
                                                                        <Card>
                                                                            <CardBody>
                                                                                <ListGroup>
                                                                                    {element.contenido.length ? element.contenido.map(content =>
                                                                                        <ListGroupItem className="btn text-left border-1" onClick={() => this.test(content.componente)}>{content.titulo}</ListGroupItem>
                                                                                    ) : <div />}
                                                                                </ListGroup>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </Collapse>
                                                                </div>
                                                            )}

                                                            <div>
                                                                <button active type="button" onClick={this.grupo} class="list-group-item list-group-item-action">Grupo</button>
                                                            </div>

                                                            <div>
                                                                <button active type="button" onClick={this.toggleDel} class="list-group-item list-group-item-action bg-danger text-light">Eliminar cuenta</button>
                                                            </div>

                                                            <div>
                                                                <button active type="button" onClick={() => this.logOut()} class="list-group-item list-group-item-action bg-secondary text-light">Cerrar Sesion</button>
                                                            </div>

                                                        </ListGroup>
                                                    </div>
                                                </Card>
                                            </Col>

                                            <Col xs="12" md="7">
                                                <Card className="container-fluid h-100">
                                                        {this.state.vista}
                                                </Card>
                                            </Col>

                                        </Row>
                                    </Container >

                                    <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                                        className="modal-md">
                                        <ModalHeader className="bg-danger" toggle={() => this.toggleDel()}><div className="text-light">Eliminar</div></ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col>
                                                    <Card className="p-3 text-center">
                                                        ¿Esta seguro de que desea eliminar esta cuenta de usuario?, Anota <text className="font-weight-bold" >{sessionStorage.getItem('usuario')}</text> en el campo
                                                        <CardBody>
                                                            <Form onSubmit={this.eliminar.bind(this)}>
                                                                <Input type="text" name="eliminar" onChange={this.setValue.bind(this,"eliminar")} className="w-100"/>
                                                                
                                                                <Row>
                                                                    <Input type="submit" value="Eliminar cuenta" className="mt-3 bg-danger text-light w-50"/>
                                                                    <Input type="button" value="Cancelar" onClick={() => this.toggleDel()} className="mt-3 bg-dark text-light w-50"/>
                                                                </Row>
                                                            </Form>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>

                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Footer />
            </html>
        )
    }
}
